import script from "./PdfControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./PdfControls.vue?vue&type=script&setup=true&lang=ts"

import "./PdfControls.vue?vue&type=style&index=0&id=8ee37af4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ee37af4"]])

export default __exports__